import { render, staticRenderFns } from "./TextAndImageFive.vue?vue&type=template&id=1b7ad631&scoped=true&"
import script from "./TextAndImageFive.vue?vue&type=script&lang=js&"
export * from "./TextAndImageFive.vue?vue&type=script&lang=js&"
import style0 from "./TextAndImageFive.vue?vue&type=style&index=0&id=1b7ad631&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ad631",
  null
  
)

export default component.exports